export default function Grid({
  children,
  cols = { default: 1, md: 2, lg: 3 },
  gap = 6,
  className = '',
}) {
  // Convert cols object to Tailwind classes
  const getColsClass = () => {
    const { default: defaultCols = 1, sm, md, lg, xl } = cols;

    let classes = `grid-cols-${defaultCols}`;
    if (sm) classes += ` sm:grid-cols-${sm}`;
    if (md) classes += ` md:grid-cols-${md}`;
    if (lg) classes += ` lg:grid-cols-${lg}`;
    if (xl) classes += ` xl:grid-cols-${xl}`;

    return classes;
  };

  return (
    <div className={`grid ${getColsClass()} gap-${gap} ${className}`}>
      {children}
    </div>
  );
}

// Convenience exports for common grid layouts
export function Grid1({ children, gap = 6, className = '' }) {
  return (
    <div className={`grid grid-cols-1 gap-${gap} ${className}`}>
      {children}
    </div>
  );
}

export function Grid2({ children, gap = 6, className = '' }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-${gap} ${className}`}>
      {children}
    </div>
  );
}

export function Grid3({ children, gap = 6, className = '' }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-${gap} ${className}`}>
      {children}
    </div>
  );
}

export function Grid4({ children, gap = 6, className = '' }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-${gap} ${className}`}>
      {children}
    </div>
  );
}

export function GridAuto({ children, minWidth = '250px', gap = 6, className = '' }) {
  return (
    <div
      className={`grid gap-${gap} ${className}`}
      style={{ gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}, 1fr))` }}
    >
      {children}
    </div>
  );
}
